export interface AlertDto {
  alertId: number;
  parentId: number;
  details: string | null;
  alertTypeId: number;
  alertStartDate: moment.Moment | null;
  alertStartTime: string;
  alertEndDate: moment.Moment | null;
  alertEndTime: string;
  everyDay: boolean | true;
  allDay?: boolean | false;
}

export enum AlertTypeEnum {
  Airport = 1,
  Person = 2,
  Passenger = 3,
  Crew = 4,
  Country = 5,
  State = 6,
  County = 7,
  City = 8,
  Allergy = 9,
  ExpiredDocument = 10,
  CrewCurrencyTraining = 11
}
